import { type ReactNode } from "react";
import type { CMSColumnLinksDTO } from "~/features/cms/types/dto";
import { LinkList, LinkListItem } from "~/common/components/LinkList/LinkList";
import DescriptionIcon from "@mui/icons-material/Description";
import LockIcon from "@mui/icons-material/Lock";
import MenuIcon from "@mui/icons-material/Menu";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

interface Props extends Omit<CMSColumnLinksDTO, "type"> {
  className?: string;
}

const CMS_ICON_MAP: Partial<Record<NonNullable<CMSColumnLinksDTO["icon"]>, ReactNode>> = {
  FileList: <DescriptionIcon sx={{ fontSize: 24 }} />,
  List: <MenuIcon sx={{ fontSize: 24 }} />,
  Lock: <LockIcon sx={{ fontSize: 24 }} />,
  Eye: <VisibilityIcon sx={{ fontSize: 24 }} />,
  EyeOff: <VisibilityOffIcon sx={{ fontSize: 24 }} />,
};

export const CMSColumnLinks = (props: Props) => {
  return (
    <LinkList
      title={props.headline}
      titleIcon={props.icon ? CMS_ICON_MAP[props.icon] : undefined}
    >
      {props.links.map((link, index) => (
        <LinkListItem
          key={index}
          linkType={link.urlType}
          href={link.url}
          headline={link.title}
          subheadline={link.subtitle}
        />
      ))}
    </LinkList>
  );
};
